import { DeviceTypeRepository } from '@telespot/domain';

export interface ICountDeviceTypesQuery {
  /**
   * Counts device types matching the optional search term. Repository errors
   * propagate so the caller can update its error state.
   */
  execute(searchTerm?: string): Promise<number>;
}

export class CountDeviceTypesQuery implements ICountDeviceTypesQuery {
  constructor(private readonly deviceTypeRepository: DeviceTypeRepository) {}

  public async execute(searchTerm?: string): Promise<number> {
    return this.deviceTypeRepository.count(searchTerm);
  }
}
